import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content gap-25"
}
const _hoisted_2 = { class: "d-flex gap-20 justify-content-between w-100 flex-md-row flex-column" }
const _hoisted_3 = { class: "d-flex gap-20 justify-content-between align-items-end w-100 flex-md-row flex-column" }
const _hoisted_4 = { class: "h-fit d-flex justify-content-end w-25 w-sm-100 flex-column" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "divider mt-0 mb-0" }, null, -1)
const _hoisted_7 = { class: "h-fit d-flex justify-content-end w-25 w-sm-100 flex-column" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "divider mt-0 mb-0" }, null, -1)
const _hoisted_10 = { class: "w-75 d-flex gap-20 w-sm-100" }
const _hoisted_11 = { class: "h-fit d-flex justify-content-end w-25 flex-column w-sm-100" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "divider mt-0 mb-0" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "fs-sm pdl-20 fw-light"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-plus" })
], -1)
const _hoisted_16 = {
  key: 2,
  class: "d-flex w-full gap-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary action-btn"
}, " Update ", -1)
const _hoisted_18 = { id: "two-fa-form" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "w-100 mb-30 sm-fs-base" }, " Two-Factor Authentication (Required) ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Preferred Method", -1)
const _hoisted_21 = { class: "radio-group primary bold" }
const _hoisted_22 = { class: "radio-buttons align-items-start flex-md-row flex-column sm-mb-20" }
const _hoisted_23 = {
  for: "participant-phone",
  class: "d-flex pdr-15"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "pdl-10" }, "Mobile Phone", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("small", { class: "pdt-10" }, "Phone number for Authentication", -1)
const _hoisted_27 = { class: "fw-medium pdt-10" }
const _hoisted_28 = {
  for: "participant-email",
  class: "d-flex"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "pdl-10" }, "Email Code", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("small", { class: "pdt-10" }, "Email Address for Authentication", -1)
const _hoisted_31 = { class: "fw-medium pdt-10 sm-fs-sm" }
const _hoisted_32 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SecurityQuestionSelect = _resolveComponent("SecurityQuestionSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts, {
      error: $setup.localErrors.General,
      success: $setup.success
    }, null, 8, ["error", "success"]),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_TextInput, {
              type: "text",
              label: "First Name",
              placeholder: "Enter First Name",
              max: 25,
              modelValue: $setup.userInfo.FirstName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userInfo.FirstName) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_TextInput, {
              type: "text",
              label: "Middle Name",
              placeholder: "Enter Middle Name",
              max: 12,
              modelValue: $setup.userInfo.MiddleName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userInfo.MiddleName) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_TextInput, {
              type: "text",
              label: "Last Name",
              placeholder: "Enter Last Name",
              max: 25,
              modelValue: $setup.userInfo.LastName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.userInfo.LastName) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_TextInput, {
              type: "text",
              label: "Designation",
              placeholder: "Enter Designation",
              max: 100,
              modelValue: $setup.userInfo.Designation,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userInfo.Designation) = $event)),
              readonly: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("form", _hoisted_3, [
            _createVNode(_component_TextInput, {
              type: "text",
              name: "phone",
              label: "Phone",
              placeholder: "Phone",
              max: 30,
              modelValue: $setup.userPhone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.userPhone) = $event)),
              required: true,
              "custom-class": "w-75 w-sm-100",
              readonly: true
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-secondary toggle-control lh-1 text-nowrap h-fit",
                disabled: $setup.loadingUpdate['password'],
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updatePhone && $setup.updatePhone(...args)), ["prevent"]))
              }, " Change Phone no ", 8, _hoisted_5)
            ])
          ]),
          _hoisted_6,
          _createElementVNode("form", {
            id: "email-change-form",
            class: "d-flex gap-20 justify-content-between align-items-end w-100 flex-md-row flex-column",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateEmail && $setup.updateEmail(...args)), ["prevent"]))
          }, [
            _createVNode(_component_TextInput, {
              type: "email",
              modelValue: $setup.userEmail,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.userEmail) = $event)),
              label: "Email Address",
              placeholder: $setup.participantStore.userEmail,
              readonly: true,
              "custom-class": "w-75  w-sm-100"
            }, null, 8, ["modelValue", "placeholder"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-secondary toggle-control lh-1 text-nowrap h-fit",
                disabled: $setup.loadingUpdate['password']
              }, " Change Email Address ", 8, _hoisted_8)
            ])
          ], 32),
          _hoisted_9,
          _createElementVNode("form", {
            id: "password-change-form",
            class: "d-flex gap-20 justify-content-between align-items-end w-100 flex-md-row flex-column",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updatePassword && $setup.updatePassword(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_TextInput, {
                type: "password",
                label: "New Password",
                placeholder: "Enter New password",
                modelValue: $setup.password,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.password) = $event)),
                name: "password",
                error: $setup.localErrors.password
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_TextInput, {
                type: "password",
                label: "Confirm Password",
                placeholder: "Enter Confirm New password",
                modelValue: $setup.passwordConfirmation,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.passwordConfirmation) = $event)),
                name: "password_confirmation",
                error: $setup.localErrors.password_confirmation
              }, null, 8, ["modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-secondary toggle-control lh-1 text-nowrap h-fit",
                disabled: $setup.loadingUpdate['password']
              }, " Change Password ", 8, _hoisted_12)
            ])
          ], 32),
          _hoisted_13,
          _createElementVNode("form", {
            id: "security-questions-form",
            class: "form account-settings",
            onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateSecurityQuestion && $setup.updateSecurityQuestion(...args)), ["prevent"]))
          }, [
            _createElementVNode("h3", null, [
              _createTextVNode(" Security Questions "),
              ($setup.numberOfQuestions > 1)
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, " *Setup at least 3 Security Questions."))
                : _createCommentVNode("", true)
            ]),
            ($setup.userQuestions.length || $setup.selectedQuestions.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.selectedQuestions.length, (index) => {
                  return (_openBlock(), _createBlock(_component_SecurityQuestionSelect, {
                    key: index,
                    label: "Security Question",
                    index: index,
                    options: $setup.availableQuestionsForSelect(`select${index}`).value,
                    userQuestion: $setup.userQuestions[index - 1],
                    "selected-question": $setup.selectedQuestions[index - 1],
                    questionId: $setup.userQuestions[index - 1]?.ID,
                    resetInputs: $setup.resetInputs,
                    showAddNewQuestion: $setup.showAddNewQuestion,
                    onHandleQuestions: $setup.handleQuestions,
                    onDelete: $setup.removeQuestion,
                    onToggleEdit: $setup.editQuestion
                  }, null, 8, ["index", "options", "userQuestion", "selected-question", "questionId", "resetInputs", "showAddNewQuestion", "onHandleQuestions", "onDelete", "onToggleEdit"]))
                }), 128))
              : _createCommentVNode("", true),
            ($setup.selectedQuestions.length < 3)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "",
                  onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => ($setup.addNewQuestion && $setup.addNewQuestion(...args)), ["prevent"])),
                  class: "btn btn-secondary add-btn"
                }, [
                  _hoisted_15,
                  _createTextVNode(" Add New Security Question ")
                ]))
              : _createCommentVNode("", true),
            ($setup.hasEditable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => ($setup.discardChanges && $setup.discardChanges(...args)), ["prevent"])),
                    class: "btn btn-secondary action-btn"
                  }, " Discard ")
                ]))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("form", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", {
                  class: _normalizeClass(["radio-button flex-column w-fit align-items-start rounded", { 'bg-white': $setup.preferredMethod == 'P' }])
                }, [
                  _createElementVNode("label", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "participant-phone",
                      name: "method",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.preferredMethod) = $event)),
                      class: "pdr-5",
                      value: "P",
                      disabled: !$setup.userPhone,
                      onChange: _cache[15] || (_cache[15] = ($event: any) => ($setup.updatePreferredMethod('P')))
                    }, null, 40, _hoisted_24), [
                      [_vModelRadio, $setup.preferredMethod]
                    ]),
                    _hoisted_25
                  ]),
                  ($setup.preferredMethod == 'P' && !$setup.loadingPreferred)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_26,
                        _createElementVNode("p", _hoisted_27, [
                          _createTextVNode(_toDisplayString($setup.userPhone) + " ", 1),
                          _createElementVNode("i", {
                            class: "iatse-icon-edit ml-10 fw-bold plan-modal",
                            onClick: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updatePhone && $setup.updatePhone(...args)), ["prevent"]))
                          })
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["radio-button flex-column w-fit align-items-start rounded", { 'bg-white': $setup.preferredMethod == 'E' }])
                }, [
                  _createElementVNode("label", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "participant-email",
                      name: "method",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.preferredMethod) = $event)),
                      class: "pdr-5",
                      value: "E",
                      onChange: _cache[18] || (_cache[18] = ($event: any) => ($setup.updatePreferredMethod('E')))
                    }, null, 544), [
                      [_vModelRadio, $setup.preferredMethod]
                    ]),
                    _hoisted_29
                  ]),
                  ($setup.preferredMethod == 'E' && !$setup.loadingPreferred)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_30,
                        _createElementVNode("p", _hoisted_31, [
                          _createTextVNode(_toDisplayString($setup.participantStore.userEmail) + " ", 1),
                          _createElementVNode("i", {
                            class: "iatse-icon-edit ml-10 fw-bold plan-modal",
                            onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateEmail && $setup.updateEmail(...args)), ["prevent"]))
                          })
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]),
            (!$setup.userPhone)
              ? (_openBlock(), _createElementBlock("small", _hoisted_32, "Please add your phone number above to enable this option."))
              : _createCommentVNode("", true)
          ])
        ]))
  ], 64))
}